<div class="col-md-12 col-xs-12" style="overflow-x:auto;">
  <div *ngIf="!viewmembersearch" class="buttontop btntop col-lg-11">
    <table>
      <tr>
        <td *ngIf="action!=='new' && (can_edit_member_baseinfo || useraccess?.edit_own_info)">
          <button class="btn border" (click)="disableForm(false)" [disabled]="disable">Ändra</button>
        </td>
        <td *ngIf="(useraccess?.edit_baseinfo && disable) || disable" style="margin-left:10px;">
          <button type="submit" class="btn border" [disabled]="!memberform?.valid || !memberform.dirty" (click)="saveForm()">Spara</button>
        </td>
        <td *ngIf="(useraccess?.edit_baseinfo && disable) || disable" style="margin-left:10px;">
          <button type="submit" (click)="cancel()" class="btn border">Avbryt</button>
        </td>
        <td>
          <button class="btn border" *ngIf="action !== 'new' && !disable && view_matrix_card" (click)="viewMatrix()">Matrikelkort</button>
        </td>
        <td *ngIf="memberaccess.userid === memberaccess.memberid && action !== 'new' && !disable"><button class="btn border" (click)="changeMyPassword()">Byt ditt
            lösenord</button></td>
        <td *ngIf="action !== 'new' && can_change_password && memberaccess?.userid !== memberaccess?.memberid"><button class="btn btn-border" (click)="changePasswordForMember()">Byt medlems lösenord</button></td>
     <td *ngIf="hasMail">
      <button class="btn btn-border" (click)="viewSentMails()">Visa mina skickade mejl</button>
     </td>

      <td *ngIf="memberaccess.userid === 30127 || memberaccess.userid === 2058730">
      <button class="btn btn-border" (click)="viewFailedMails()">Visa misslyckade mejl</button>
     </td>
     
      </tr>
    </table>
  </div>
  <div id="contentToConvert" class="col-xs-12 col-xl-12">
    <div *ngIf="!institution && action === 'new'" style="width:300px;">
      <p-select [options]="institutionslist" [(ngModel)]="selectedinstitution" [filter]="true" [showClear]="true" placeholder="Välj institution" [style]="{ width: '100%' }" (onChange)="setInstitution()" appendTo="body" required></p-select>
    </div>
    <form [formGroup]="memberform" autocomplete="off" *ngIf="action !== 'new' || memberform.get('institutionId').value">
      <div *ngIf="institution"><b>Skapa ny medlem i Orden</b> [{{institution.shortName}} {{institution.name}}]</div><br>
      <div *ngIf="action === 'new' && !viewmembersearch" class="row">
        <div *ngIf="!institution" class="col-sm-2" style="min-width: 100px;max-width: 100px;display: none;">
          <label>
            Institutionsid
          </label>
          <input id="institutionId" type="text" class="form-control form-control-sm" formControlName="institutionId" readonly>
        </div>

        <div class="col-md-4">
          <label>Invigningsdatum</label>
          <app-calendar [form]="memberform" formName="initiatedDate" [required]=true></app-calendar>
        </div>
      </div>
      <div class="d-flex justify-content-start flex-wrap ms-2 me-2 gap-3" style="margin-top:10px;">
        <div style="min-width:450px;">
          <div formGroupName="member">
            <div *ngIf="!viewmembersearch" style="min-width:150px;">
              <mat-expansion-panel *ngIf="action !== 'new'" [expanded]=true>
                <mat-expansion-panel-header [expandedHeight]="'48px'">
                  <mat-panel-title>
                    Medlem
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
                <div class="d-flex justify-content-start">
                  <div>
                    <img *ngIf="previewUrl" mat-card-image src='{{previewUrl}}' width="100" style="border-radius:5px;">
                    <img *ngIf="!previewUrl && !imageToShow" src="../../../../assets/bildsaknas.jpg" width="100" style="border-radius:5px;">
                   <div class="d-flex ms-2 mt-2 justify-content-start gap-2">
                    
                    <a *ngIf="memberform.enabled && memberaccess?.edit_baseinfo"  [routerLink]="['/loadphoto/' + memberid]" class="me-2">
                      <span class="fa-stack fa-lg" title="Lägg till/Byt ut foto">
                          <i class="fa fa-camera fa-stack-1x" style="font-size: 2.0em"></i>
                          <i class="fa fa-circle fa-stack-1x" style="color:white; font-size:1.2em; top:-8px; left:8px; position:absolute;"></i>
                          <i class="fa fa-plus fa-stack-1x" style="font-size:1.2em; top:-8px; left:8px; position:absolute; color:green;"></i>
                      </span>
                    </a>
                    
                    <i *ngIf="imageToShow && memberform.enabled && memberaccess?.edit_baseinfo" class="fa fa-trash ms-3" aria-hidden="true" title="Radera foto" style="font-size:20px;font-weight:bold;color: #0067C5;" (click)="removePhoto()"></i>
                  </div>
                  </div>
                  <div class="ms-3">
                     <table width="100%">
                      <tr>
                        <td></td>
                        <td>
                          <b>{{givenName.value | uppercase}} {{familyName.value | uppercase}}</b>
                        </td>
                      </tr>
                      <tr style="height:20px;"></tr>
                      <tr>
                        <td>
                          <i class="fa fa-phone" aria-hidden="true"></i>
                        </td>
                        <td *ngIf="memberform.disabled">
                          <a href="tel://{{phone.value}}">{{phone.value}}</a>
                        </td>
                        <td *ngIf="memberform.enabled">
                          {{phone.value}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <i class="fa fa-phone" aria-hidden="true"></i>
                        </td>
                        <td *ngIf="memberform.disabled">
                          <a href="tel://{{phone2.value}}">{{phone2.value}}</a>
                        </td>
                        <td *ngIf="memberform.enabled">{{phone2.value}}</td>
                      </tr>
                      <tr>
                        <td>
                          <i class="fa fa-mobile" aria-hidden="true"></i>
                        </td>
                        <td *ngIf="memberform.disabled"><a href="tel://{{phoneMobile.value}}">{{phoneMobile.value}}</a>
                         
                        </td>
                        <td *ngIf="memberform.enabled">{{phoneMobile.value}}</td>
                      </tr>
                      <tr>
                        <td>
                          <i class="fa fa-envelope-o" aria-hidden="true"></i>
                        </td>
                        <td *ngIf="memberform.disabled"><a href="mailto:{{email.value}}">{{email.value}}</a></td>
                        <td *ngIf="memberform.enabled">{{email.value}}</td>
                      </tr>
                      <tr>
                        <td>
                          <i class="fa fa-envelope-o" aria-hidden="true"></i>
                        </td>
                        <td *ngIf="memberform.disabled"><a href="mailto:{{email2.value}}">{{email2.value}}</a></td>
                        <td *ngIf="memberform.enabled">{{email2.value}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="row">
                
                  <div class="col-md-8 col-sm-8 col-xs-8" style="width:100%;">
                    <table width="100%">
                      <tr>
                        <td>
                          <hr>
                        </td>
                        <td>
                          <hr>
                        </td>
                      </tr>
                      <tr *ngIf="!uploadImage">
                        <td>
                          <i class="fa fa-address-card-o" aria-hidden="true"></i>
                        </td>
                        <td>{{homeAddress_street.value}}</td>
                      </tr>
                      <tr *ngIf="!uploadImage">
                        <td></td>
                        <td>{{homeAddress_zipCode.value}} {{homeAddress_city.value}}</td>
                      </tr>
                      <tr *ngIf="!uploadImage">
                        <td></td>
                        <td>{{homeAddress_country.value}}</td>
                      </tr>
                      <br>
                      <tr *ngIf="uploadImage">
                        <td colspan="2">
                          <button *ngIf="previewUrl" class="btn border" (click)="cancelImageUpload()">Avbryt</button>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div *ngIf="!uploadImage" style="height:10px;">
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <div style="min-width:150px;">
              <mat-expansion-panel *ngIf="!viewmembersearch" [expanded]="false || action === 'new' || !memberform.disabled" class="accordionmargin">
                <mat-expansion-panel-header [expandedHeight]="'48px'">
                  <mat-panel-title>
                    Medlem - {{memberid}}
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
                <div class="form-group">
                  <label for="givenName">
                    Förnamn
                  </label>
                  <input [required]="action !== 'search'" type="text" class="form-control form-control-sm" id="givenName" formControlName="givenName" [value]="givenName.value | capitalize" [readonly]="!memberaccess.edit_baseinfo && action !== 'new'">
                  <span *ngIf="(givenName.dirty || givenName.touched) && givenName.invalid && givenName.errors.required">
                    Förnamn är obligatoriskt.
                  </span>
                </div>
                <div class="form-group">
                  <label for="otherForeNames">
                    Övriga Förnamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="otherForeNames" formControlName="otherForeNames" [value]="oterForeNames?.value | capitalize" [readonly]="!memberaccess.edit_baseinfo && action !== 'new'">
                </div>
                <div class="form-group">
                  <label for="middleName">
                    Mellannamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="middleName" formControlName="middleName" [value]="middleName.value | capitalize" [readonly]="!memberaccess.edit_baseinfo && action !== 'new'">
                </div>
                <div class="form-group">
                  <label for="familyName">
                    Efternamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="familyName" formControlName="familyName" [value]="familyName.value | capitalize" required [readonly]="!memberaccess.edit_baseinfo && action !== 'new'">
                  <span *ngIf="(familyName.dirty || familyName.touched) && familyName.invalid && familyName.errors.required">
                    Efternamn är obligatoriskt.
                  </span>
                </div>
                <div class="form-group">
                  <label for="formerName">
                    Tidigare efternamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="formerName" formControlName="formerName" [value]="formerName.value | capitalize" [readonly]="!memberaccess.edit_baseinfo && action !== 'new'">
                </div>
                <div class="form-group">
                  <label for="title">
                    Yrke/Titel
                  </label>
                  <input type="text" class="form-control form-control-sm" id="title" formControlName="title" [value]="title.value" [readonly]="!memberaccess.edit_baseinfo && action !== 'new'">
                </div>
                <div class="form-group" style="width: 120px;">
                  <label for="birthday">
                    Födelsedatum
                  </label>
                  <input type="text" class="form-control form-control-sm" id="birthday" (change)="servicedbirthday=birthday?.value" mask="0000-00-00" formControlName="birthday" title="Format: YYYY-MM-DD" [value]=servicedbirthday required
                    [readonly]="!memberaccess.edit_baseinfo && action !== 'new'" />
                  
                </div>
                <div *ngIf="action !== 'new'" class="form-group">
                  <label for="mentorMemberId">
                    Fadder
                  </label>
                  <div style="display: flex;">
                    <input type="text" style="width:80px;" class="form-control form-control-sm" id="mentorMemberId" formControlName="mentorMemberId" readonly>
                    <i *ngIf="memberform.get('member').get('mentorMemberId').value" class="viewmentor fa fa-external-link" (click)="viewMentor()" title="Visa medlem"></i>
                    <input type="text" class="form-control form-control-sm" formControlName="mentorName" readonly>
                  </div>
                  <button *ngIf="!viewmembersearch && disable && !memberform.get('member').get('id')" (click)="searchMentor()">Sök</button>
                  <button *ngIf="!viewmembersearch && disable && memberform.get('member').get('id') && memberaccess.edit_baseinfo" (click)="searchMentor()">Byt</button>
                  <button *ngIf="!viewmembersearch && disable && memberform.get('member').get('id') && memberaccess.edit_baseinfo" (click)="removeMentor()">Ta bort</button>
                </div>
                <div class="form-group" style="width:220px;">
                  <label for="localId">
                    Lokalt medlemsnummer
                  </label>
                  <input type="text" class="form-control form-control-sm" id="localId" formControlName="localId" [value]="localId.value" [readonly]="!memberaccess.edit_baseinfo && action !== 'new'">
                </div>
                <div class="form-group" style="border:none;">
                  <label for="isSubscriber" class="form-check-label">
                    <mat-checkbox class="form-control" id="isSubscriber" formControlName="isSubscriber">SOFT-prenumeration
                    </mat-checkbox>
                  </label>
                </div>
              </mat-expansion-panel>
            </div>
            <mat-expansion-panel *ngIf="!viewmembersearch" [expanded]=accordionstatus?.phonenumber (opened)="updateAccordionStatus('phonenumber', true)" (closed)="updateAccordionStatus('phonenumber', false)" class="accordionmargin">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  Telefonnummer
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="form-row">
                <div class="form-group col-sm-6">
                  <label for="phone">
                    Telefon 1
                  </label>
                  <div *ngIf="memberform.disabled && mobiledevice"> <a *ngIf="memberform.disabled" href="tel://{{memberform.get('member').get('phone')?.value}}">{{memberform.get('member').get('phone')?.value}}</a>
                  </div>
                  <input *ngIf="memberform.enabled || !mobiledevice" type="text" class="form-control form-control-sm" id="phone" formControlName="phone">
                </div>
                <div class="form-group col-sm-6">
                  <label for="phone2">
                    Telefon 2
                  </label>
                  <div *ngIf="memberform.disabled"> <a *ngIf="memberform.disabled" href="tel://{{memberform.get('member').get('phone2')?.value}}">{{memberform.get('member').get('phone2')?.value}}</a>
                  </div>
                  <input *ngIf="memberform.enabled" type="text" class="form-control form-control-sm" id="phone2" formControlName="phone2">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-sm-6">
                  <label for="phoneWork">
                    Arbetstelefon
                  </label>
                  <div *ngIf="memberform.disabled"> <a *ngIf="memberform.disabled" href="tel://{{memberform.get('member').get('phoneWork')?.value}}">{{memberform.get('member').get('phoneWork')?.value}}</a>
                  </div>
                  <input *ngIf="memberform.enabled" type="text" class="form-control form-control-sm" id="phoneWork" formControlName="phoneWork">
                </div>
                <div class="form-group col-sm-6">
                  <label for="phoneMobile">
                    Mobiltelefon
                  </label>
                  <div *ngIf="memberform.disabled"> <a *ngIf="memberform.disabled" href="tel://{{memberform.get('member').get('phoneMobile')?.value}}">{{memberform.get('member').get('phoneMobile')?.value}}</a>
                  </div>
                  <input *ngIf="memberform.enabled" type="text" class="form-control form-control-sm" id="phone" formControlName="phoneMobile">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-sm-6">
                  <label for="fax">
                    Fax
                  </label>
                  <div *ngIf="memberform.disabled">
                    {{memberform.get('member').get('fax')?.value}}
                  </div>
                  <input *ngIf="memberform.enabled" type="text" class="form-control form-control-sm" id="fax" formControlName="fax">
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="!viewmembersearch" [expanded]=accordionstatus?.email (opened)="updateAccordionStatus('email', true)" (closed)="updateAccordionStatus('email', false)" class="accordionmargin">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  E-post och Hemsida
                </mat-panel-title>
               
              </mat-expansion-panel-header>
              <div class="form-group">
                <label for="email">
                  E-post 1
                </label>
                <div *ngIf="memberform.disabled"><a href="mailto:{{memberform.get('member').get('email').value}}">{{memberform.get('member').get('email').value}}</a>
                </div>
                <input *ngIf="memberform.enabled" type="text" class="form-control form-control-sm" id="email" formControlName="email">
              </div>
              <div>
                <label for="email2">
                  E-post 2
                </label>
                <div *ngIf="memberform.disabled"><a href="mailto:{{memberform.get('member').get('email2').value}}">{{memberform.get('member').get('email2').value}}</a>
                </div>
                <input *ngIf="memberform.enabled" type="text" class="form-control form-control-sm" id="email2" formControlName="email2">
              </div>
              <div class="form-group">
                <label for="webSite">
                  Hemsida
                </label>
                <input type="text" class="form-control form-control-sm" id="webSite" formControlName="webSite">
              </div>
            </mat-expansion-panel>
          </div>
        </div>






        <div style="min-width:400px;">
          <div *ngIf="!viewmembersearch">
            <div formGroupName="member">
              <div formGroupName="homeAddress">
                <mat-expansion-panel [expanded]="accordionstatus.homeaddress || action === 'new'" (opened)="updateAccordionStatus('homeaddress', true)" (closed)="updateAccordionStatus('homeaddress', false)">
                  <mat-expansion-panel-header [expandedHeight]="'48px'">
                    <mat-panel-title>
                      Hemadress
                    </mat-panel-title>
                 
                  </mat-expansion-panel-header>
                  <div class="form-group">
                    <label for="homeAddress_careOf">
                      C/O
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress_careOf" formControlName="careOf">
                  </div>
                  <div class="form-group">
                    <label for="homeAddress_street">
                      Gata/Box
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress_street" formControlName="street" required>
                  </div>
                  <div *ngIf="homeAddress_country.value==='Sverige'" class="form-group">
                    <label for="homeAddress.zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress.zipCode" mask="000 00" formControlName="zipCode" required>
                  </div>
                  <div *ngIf="homeAddress_country.value!=='Sverige'" class="form-group">
                    <label for="homeaddress.zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress.zipCode" formControlName="zipCode">
                  </div>
                  <div class="form-group">
                    <label for="homeAddress_city">
                      Ort
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress_city" formControlName="city" required>
                  </div>
                  <div class="form-group">
                    <label for="country">Land</label>
                    <select class="form-control form-control-sm" id="country" formControlName="country" required>
                      <option></option>
                      <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
                    </select>
                    <span *ngIf="(homeAddress_country.dirty || homeAddress_country.touched) && homeAddress_country.invalid && homeAddress_country.errors.required">
                      Land är obligatoriskt.
                    </span>
                  </div>
                </mat-expansion-panel>
              </div>
              <div formGroupName="workAddress">
                <mat-expansion-panel [expanded]=accordionstatus.workaddress (opened)="updateAccordionStatus('workaddress', true)" (closed)="updateAccordionStatus('workaddress', false)" class="accordionmargin">
                  <mat-expansion-panel-header [expandedHeight]="'48px'">
                    <mat-panel-title>
                      Arbetsadress
                    </mat-panel-title>
                
                  </mat-expansion-panel-header>
                  <div class="form-group">
                    <label for="workAddress_careOf">
                      C/O
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress_careOf" formControlName="careOf">
                  </div>
                  <div class="form-group">
                    <label for="workAddress_street">
                      Gata/Box
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress_street" formControlName="street">
                  </div>
                  <div *ngIf="workAddress_country.value==='Sverige'" class="form-group">
                    <label for="workAddress.zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress.zipCode" mask="000 00" formControlName="zipCode">
                  </div>
                  <div *ngIf="workAddress_country.value!=='Sverige'" class="form-group">
                    <label for="workAddress.zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress.zipCode" formControlName="zipCode">
                  </div>
                  <div class="form-group">
                    <label for="workAddress_city">
                      Ort
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress_city" formControlName="city">
                  </div>
                  <div class="form-group">
                    <label for="workcountry">Land</label>
                    <select class="form-control form-control-sm" id="workcountry" formControlName="country" [required]="workAddress_street.value!=='' && workAddress_street.value!==null">
                      <option></option>
                      <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
                    </select>
                  </div>
                </mat-expansion-panel>
              </div>
              <div formGroupName="otherAddress">
                <mat-expansion-panel [expanded]=accordionstatus.otheraddress (opened)="updateAccordionStatus('otheraddress', true)" (closed)="updateAccordionStatus('otheraddress', false)" class="accordionmargin">
                  <mat-expansion-panel-header [expandedHeight]="'48px'">
                    <mat-panel-title>
                      Annan adress
                    </mat-panel-title>
                  
                  </mat-expansion-panel-header>
                  <div class="form-group">
                    <label for="otherAddress_careOf">
                      C/O
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress_careOf" formControlName="careOf">
                  </div>
                  <div class="form-group">
                    <label for="otherAddress_street">
                      Gata/Box
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress.street" formControlName="street">
                  </div>
                  <div *ngIf="otherAddress_country.value==='Sverige'" class="form-group">
                    <label for="otherAddress_zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress_zipCode" mask="000 00" formControlName="zipCode">
                  </div>
                  <div *ngIf="otherAddress_country.value !== 'Sverige'" class="form-group">
                    <label for="otherAddress_zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress_zipCode" formControlName="zipCode">
                  </div>
                  <div class="form-group">
                    <label for="otherAddress_city">
                      Ort
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress_city" formControlName="city">
                  </div>
                  <div class="form-group">
                    <label for="othercountry">Land</label>
                    <select class="form-control form-control-sm" id="othercountry" formControlName="country" [required]="otherAddress_street.value!=='' && otherAddress_street.value!==null">
                      <option></option>
                      <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
                    </select>
                  </div>
                </mat-expansion-panel>
              </div>
            </div>
          </div>
        </div>





        <div *ngIf="!viewmembersearch && action !== 'new' && !disable" style="min-width:500px;">
          <mat-expansion-panel *ngIf="action !== 'new' && !disable" [expanded]=accordionstatus.actualmembership (opened)="updateAccordionStatus('actualmembership', true)" (closed)="updateAccordionStatus('actualmembership', false)">
            <mat-expansion-panel-header [expandedHeight]="'48px'">
              <mat-panel-title>
                Medlemskap
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-membership memberId={{memberid}} givenname={{givenName.value}} familyname={{familyName.value}} time={{time}} primarylodgeformember={{primarylodgeformember}} [isadminformember]="isAdminForMember" (doChangePrimaryInstitution)="changePrimaryInstitution1($event)" [showall]="showall"
              [isClerk]="isClerk" [isSysAdmin]="isSysAdmin" (doTerminate)="terminateMembership2($event)"></app-membership>
          </mat-expansion-panel>
          <mat-expansion-panel *ngIf="action !== 'new' && !disable" [expanded]=accordionstatus.actualcommitment (opened)="updateAccordionStatus('actualcommitment', true)" (closed)="updateAccordionStatus('actualcommitment', false)" class="accordionmargin">
            <mat-expansion-panel-header [expandedHeight]="'48px'">
              <mat-panel-title>
                Uppdrag / Ämbeten
              </mat-panel-title>
           
            </mat-expansion-panel-header>
            <div>
              <app-memberoffices [baseinfo]="baseinfo" [showall]="showall" roleid={{useraccess?.role?.roleId}}></app-memberoffices>
            </div>
          </mat-expansion-panel>
          <div formGroupName="member" *ngIf="!viewmembersearch">
            <mat-expansion-panel *ngIf="action !== 'new'" [expanded]=accordionstatus.signs (opened)="updateAccordionStatus('signs', true)" (closed)="updateAccordionStatus('signs', false)" style="margin-top:5px;">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  Utmärkelser (Grader / Tecken)
                </mat-panel-title>
              
              </mat-expansion-panel-header>
              <app-signs [baseinfo]="baseinfo" memberid="memberid" roleid={{useraccess?.role?.roleId}}></app-signs>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="action !== 'new' && !viewmembersearch && !disable" [expanded]=accordionstatus.meetings (opened)="updateAccordionStatus('meetings', true)" (closed)="updateAccordionStatus('meetings', false)" class="accordionmargin">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  Möten
                </mat-panel-title>
               
              </mat-expansion-panel-header>
              <app-meetings institutionid=390></app-meetings>
            </mat-expansion-panel>
      
            <mat-expansion-panel *ngIf="action !== 'new' && !disable && (memberaccess?.view_memberfees || can_view_memfee)" class="accordionmargin">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  Medlemsavgifter
                </mat-panel-title>
           
              </mat-expansion-panel-header>
              <div *ngIf="memberaccess?.view_memberfees || can_view_memfee">
                <app-paidfees roleid={{roleid}}></app-paidfees>
              </div>
            </mat-expansion-panel>
          </div>
        </div>
      </div>
      <br>
    </form>
  </div>
  <div *ngIf="viewmembersearch" class="col-md-11">
    <app-searchmember [mentor]=viewmembersearch (changeMentor)="mentorSelected1($event)"></app-searchmember>
  </div>
  <div class="push"></div>
</div>
<div *ngIf="isAdmin" class="buttonbottom">
  <ng-template #childTemplate>
    <div class="row">
      <table style="margin-left: 18px;">
        <tr>
          <td *ngIf="action !== 'new' && can_edit_member_baseinfo" style="padding: 10px;padding-left: 20px;">
            <button class="btn border" (click)="disableForm(false)" [disabled]="disable">Ändra</button>
          </td>
          <td style="padding: 10px;">
            <button type="submit" class="btn border" [disabled]="(action!=='new' && !disable && !memberform.dirty) || !memberform.valid" (click)="saveForm()">Spara</button>
          </td>
          <td *ngIf="action !== 'new'" style="padding:10px;">
            <button type="submit" (click)="cancel()" class="btn border" [disabled]="memberform.disabled">Avbryt</button>
          </td>
          <td class="form-check-inline" style="margin-top:10px;">
            <label class="form-check-label">
              <mat-checkbox (change)="showall = !showall">Nuvarande</mat-checkbox>
            </label>
          </td>
        </tr>
      </table>
    </div>
  </ng-template>
  <app-footer [childTemplate]="childTemplate"></app-footer>
</div>

<p-dialog header="Lägg till medlemskap" [(visible)]="addmembership" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true">

  <app-addmembership memberid={{memberid}} givenname={{memberdata?.givenName}} familyname={{memberdata?.familyName}} (closeAdd)="closeAdd($event)"></app-addmembership>
</p-dialog>

<p-dialog header="Byt primärinstitution" [(visible)]="changeprimaryinstitution" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true" closeOnEscape=true>

  <app-changeprimaryinstitution memberid={{memberid}} givenname={{memberdata?.givenName}} familyname={{memberdata?.familyName}} primarylodgeformember={{primarylodgeformember}} (closeChange)="closeChange($event)"></app-changeprimaryinstitution>
</p-dialog>

<p-dialog header="Avsluta medlemskap" [(visible)]="terminatemembership" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true">
  <app-terminatemembership memberid={{memberdata?.id}} givenname={{memberdata?.givenName}} familyname={{memberdata?.familyName}} primarylodgeformember={{primarylodgeformember}} (closeTerminate)="closeTerminate($event)"></app-terminatemembership>

</p-dialog>

<p-dialog header="Avsluta medlemskap i läger/förening" [(visible)]="terminatemembershipcamp" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true">
  <app-terminatemembershipcamp memberid={{memberid}} givenname={{memberdata?.givenName}} familyname={{memberdata?.familyName}} (closeTerminateCamp)="closeTerminateCamp($event)"></app-terminatemembershipcamp>
</p-dialog>

<p-dialog header="Avsluta medlemskap" [(visible)]="terminatemembershipstorloge" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true">
  <app-terminatemembershipstorloge memberid={{memberid}} givenname={{memberdata?.givenName}} familyname={{memberdata?.familyName}} primarylodgeformember={{selInst}} (closeTerminateStorloge)="closeTerminateStorloge($event)"></app-terminatemembershipstorloge>
</p-dialog>

<p-dialog header="Ladda upp foto" [(visible)]="photodialog" maximizable="true" appendTo="body">
  <app-load-photo></app-load-photo>
</p-dialog>